<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-para">Dedicated to A.J.S.,<br/>and in memory of R. K. Narayan fifteen years after his death,<br/>who died in Madras in the wee hours of Sunday morning on May 13, 2001</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?d6ad2748